/* import __COLOCATED_TEMPLATE__ from './recent-transfers-table.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { computed, action, set } from '@ember/object';
import { readOnly, gt } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import { CardTender } from '@square/dashboard-protos/models/squareup/bills/tender';
import { SettlementType } from '@square/dashboard-protos/models/squareup/beemo/v2/reporting/settlements';
import Money from '@square/dashboard-money/models/money';
import { DateTime } from '@square/dashboard-protos/models/squareup/common/time';
const TRANSFER_IN_SETTLEMENT_TYPES = new Set([SettlementType.DEBIT_CARD_PAY_IN, SettlementType.DIRECT_DEPOSIT_IN, SettlementType.BALANCE_TRANSFER_IN]);
const TRANSFER_OUT_LOGO_URL = 'https://bizbank-assets.s3-us-west-1.amazonaws.com/m_category_transferout.png';
const TRANSFER_IN_LOGO_URL = 'https://bizbank-assets.s3-us-west-1.amazonaws.com/m_category_transferin.png';
const COLOR_CODE = '#FFFFFF';
const IS_PRERENDERED = false;
const BACKGROUND_COLOR_CODE = '#323A42';
const SETTLEMENT_BATCH_SIZE = 5;
const SETTLEMENT_REPORT_LITE_BEGIN = moment().subtract(1, 'years').toDate().getTime() * 1000;
const SETTLEMENT_REPORT_LITE_END = moment().toDate().getTime() * 1000;
let RecentTransfersTable = (_dec = readOnly('currentUserData.data.canSeeDepositSettings'), _dec2 = gt('recentTransfers.length', 0), _dec3 = computed('settlements'), _dec4 = computed('recentTransfers'), _class = class RecentTransfersTable extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "formatter", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    _initializerDefineProperty(this, "currentUserData", _descriptor4, this);
    _initializerDefineProperty(this, "checkingBeemoReportingApi", _descriptor5, this);
    _defineProperty(this, "isLoading", true);
    _defineProperty(this, "settlementReportsLite", void 0);
    _defineProperty(this, "settlements", void 0);
    _defineProperty(this, "unitToken", void 0);
    _defineProperty(this, "isFrozen", void 0);
    // eslint-disable-next-line dashboard/prefer-user-services
    _initializerDefineProperty(this, "canSeeDepositSettings", _descriptor6, this);
    _initializerDefineProperty(this, "hasRecentTransfers", _descriptor7, this);
  }
  get recentTransfers() {
    return this.settlements ?? [];
  }
  get recentTransferRows() {
    return this.recentTransfers.map(recentTransfer => {
      return {
        recentTransfer,
        description: this.getSettlementTypeToDisplay(recentTransfer),
        merchantImage: {
          backgroundColorCode: BACKGROUND_COLOR_CODE,
          colorCode: COLOR_CODE,
          isPrerendered: IS_PRERENDERED,
          merchantImageUrl: this.getMerchantImageUrl(recentTransfer)
        },
        transferDescription: this.getTransferDescription(recentTransfer),
        amount: this.getFormattedAmount(recentTransfer)
      };
    });
  }
  getSettlementTypeToDisplay(recentTransfer) {
    switch (recentTransfer?.settlementType) {
      case SettlementType.PAYROLL_TRANSFER:
        if (recentTransfer.settlementMoney != null && recentTransfer?.settlementMoney?.amount > 0) {
          return this.intl.t('banking.checking.settlementType.payrollTransfer');
        } else {
          return this.intl.t('banking.checking.settlementType.payrollTransferRefund');
        }
      case SettlementType.CAPITAL_TRANSFER:
        if (recentTransfer.settlementMoney != null && recentTransfer.settlementMoney?.amount > 0) {
          return this.intl.t('banking.checking.settlementType.capitalTransfer');
        } else {
          return this.intl.t('banking.checking.settlementType.capitalTransferRefund');
        }
      case SettlementType.MANUAL_INSTANT:
        return this.intl.t('banking.checking.overview.transfersTable.recent.instantTransfer');
      case SettlementType.DEBIT_CARD_PAY_IN:
      case SettlementType.DIRECT_DEPOSIT_IN:
      case SettlementType.BALANCE_TRANSFER_IN:
        return this.intl.t('banking.checking.overview.transfersTable.recent.transferIn');
      case SettlementType.STANDARD:
      case SettlementType.SCHEDULED_INSTANT:
      case SettlementType.DIRECT_DEPOSIT_OUT:
      case SettlementType.BALANCE_TRANSFER_OUT:
      default:
        return this.intl.t('banking.checking.overview.transfersTable.recent.transfer');
    }
  }
  getMerchantImageUrl(recentTransfer) {
    return recentTransfer != null && TRANSFER_IN_SETTLEMENT_TYPES.has(recentTransfer.settlementType) ? TRANSFER_IN_LOGO_URL : TRANSFER_OUT_LOGO_URL;
  }
  getTransferDescription(recentTransfer) {
    if (!recentTransfer?.token) {
      return this.intl.t('banking.checking.overview.transfersTable.pending');
    } else if (recentTransfer.bankName && recentTransfer.bankAccountSuffix) {
      return this.intl.t('banking.checking.overview.transfersTable.recent.toBank', {
        bankName: recentTransfer.bankName,
        bankAccountSuffix: recentTransfer.bankAccountSuffix
      });
    } else if (recentTransfer.cardInfo?.cardBrand && recentTransfer.cardInfo?.panSuffix) {
      const cardTransferDescriptionKey = TRANSFER_IN_SETTLEMENT_TYPES.has(recentTransfer.settlementType) ? 'banking.checking.overview.transfersTable.recent.fromCard' : 'banking.checking.overview.transfersTable.recent.toCard';
      return this.intl.t(cardTransferDescriptionKey, {
        cardBrand: CardTender.Card.Brand[recentTransfer.cardInfo.cardBrand],
        panSuffix: recentTransfer.cardInfo.panSuffix
      });
    } else if (recentTransfer.settlementType === SettlementType.BALANCE_TRANSFER_OUT) {
      return this.intl.t('banking.checking.overview.transfersTable.recent.toSquareSavings');
    } else if (recentTransfer.settlementType === SettlementType.BALANCE_TRANSFER_IN) {
      return this.intl.t('banking.checking.overview.transfersTable.recent.fromSquareSavings');
    } else {
      return null;
    }
  }
  getFormattedAmount(recentTransfer) {
    const amount = Money.fromProto(recentTransfer?.settlementMoney);
    return recentTransfer != null && TRANSFER_IN_SETTLEMENT_TYPES.has(recentTransfer.settlementType) && amount ? `+ ${this.formatter.formatMoney(amount.unsigned)}` : this.formatter.formatMoney(amount);
  }
  async getSettlementReportsLite() {
    const settlementReportLiteWrapper = await this.checkingBeemoReportingApi.getSettlementReportsLiteInRange({
      batchSize: SETTLEMENT_BATCH_SIZE,
      beginDate: DateTime.create({
        instantUsec: SETTLEMENT_REPORT_LITE_BEGIN
      }),
      endDate: DateTime.create({
        instantUsec: SETTLEMENT_REPORT_LITE_END
      }),
      subunitMerchantTokens: [this.unitToken]
    });
    return settlementReportLiteWrapper.settlements;
  }
  async getSettlementsFromTokens(settlementTokens) {
    if (settlementTokens.length > 0) {
      const settlementReportByIds = await this.checkingBeemoReportingApi.getSettlementReportByIds(settlementTokens, {
        subunitMerchantTokens: [this.unitToken]
      });
      return settlementReportByIds.settlementReports.map(settlementReport => settlementReport.settlement);
    }
    return [];
  }
  async initRecentTransfers() {
    const settlementReportsLite = await this.getSettlementReportsLite();
    const settlementTokens = settlementReportsLite.map(settlementReportLite => settlementReportLite.token);
    const settlements = await this.getSettlementsFromTokens(settlementTokens);
    set(this, 'settlementReportsLite', settlementReportsLite);
    set(this, 'settlements', settlements);
    set(this, 'isLoading', false);
  }
  viewTransferSettings() {
    this.router.transitionTo('money.settings', {
      queryParams: {
        currentUnitToken: this.unitToken
      }
    });
  }
  viewAllTransfers() {
    this.router.transitionTo('square-card.activity.transfers', {
      queryParams: {
        unitToken: this.unitToken
      }
    });
  }
  viewRecentTransfer(recentTransfer) {
    const allowSplitTransfer = this.settlementReportsLite.find(settlementReportLite => {
      return recentTransfer.token === settlementReportLite.token;
    })?.allowSplitTransfer ?? false;
    return this.router.transitionTo('money.balance.show', recentTransfer.token, this.unitToken, {
      queryParams: {
        allowSplitTransfer
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "checkingBeemoReportingApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "canSeeDepositSettings", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasRecentTransfers", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "recentTransfers", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "recentTransfers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentTransferRows", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "recentTransferRows"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initRecentTransfers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initRecentTransfers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewTransferSettings", [action], Object.getOwnPropertyDescriptor(_class.prototype, "viewTransferSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewAllTransfers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "viewAllTransfers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewRecentTransfer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "viewRecentTransfer"), _class.prototype), _class);
export { RecentTransfersTable as default };